
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 13.609 16.191"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"transform":"translate(-20.625)"}},[_c('circle',{staticClass:"a",attrs:{"cx":"3.755","cy":"3.755","r":"3.755","transform":"translate(23.676)"}}),_c('path',{staticClass:"a",attrs:{"d":"M27.43 9.386a6.805 6.805 0 00-6.805 6.805h13.61a6.805 6.805 0 00-6.805-6.805z"}})])])
          )
        }
      }
    